module.exports = __webpack_public_path__ + "img/s.95021b40.webp";